module.exports = __webpack_public_path__ + "static/media/19ESCAP22.9b2f0283.jpg";